import { autoinject } from 'aurelia-framework';
import { ApiService } from '../../utils/api-service';

export interface IScopeAM {
	id: string;
	specifier: string;
	startDate: string;
	endDate: string;
	scopeTypeId: string;
	name: string;
	serviceStructureName: string;
	serviceStructureId: string;
	fiscalYearId: string;
	organizationId: string;
	isClosed: boolean;
}

export interface IScopePlainAM {
	id: string;
	specifier: string;
	name: string;
	fiscalYearId: string;
	isClosed: boolean;
	serviceStructureId: string;
}

@autoinject
export class ScopeService {
	constructor(private http: ApiService) {
	}

	getScope(scopeId: string): Promise<IScopeAM> {
		return this.http.fetchJson(`scopes/${scopeId}`);
	}

	getScopesForFiscalYear(fiscalYearId: string): Promise<IScopePlainAM[]> {
		return this.http.fetchJson(`fiscalyears/${fiscalYearId}/scopes`);
	}

	getScopesForCustomer(customerId: string): Promise<IScopeAM[]> {
		return this.http.fetchJson(`customers/${customerId}/scopes`);
	}

	getScopesWithSameDateRangeForCustomer(customerId: string, scopeId: string): Promise<IScopeAM[]> {
		return this.http.fetchJson(`customers/${customerId}/scopes/match-date-range-of-scope/${scopeId}`);
	}
}
